import React from "react";
import { Reveal } from "./Reveal";
import { TEAM } from "../../data/content";

export const Team = () => (
  <section id="team" className="relative py-24 md:py-40 border-t border-brand-line" data-testid="team-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal className="mb-16 flex flex-col md:flex-row md:items-end justify-between gap-6">
        <div>
          <p className="overline mb-6">05 — Our people</p>
          <h2 className="font-display font-light text-4xl md:text-6xl tracking-tight text-brand-text leading-[1.02]">
            Senior partners &amp; consultants.
          </h2>
        </div>
        <p className="max-w-xs text-brand-soft font-light">
          A multidisciplinary bench of professionals with decades of practice across law, finance, HR and technology.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-brand-line border border-brand-line">
        {TEAM.map((m, i) => (
          <Reveal key={m.name} delay={(i % 4) * 0.06}>
            <article
              data-testid={`team-card-${i}`}
              className="h-full bg-brand-base p-8 group hover:bg-brand-surface transition-colors duration-500 flex flex-col"
            >
              <span className="font-mono text-[10px] text-brand-muted">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="mt-6 font-display text-2xl text-brand-text leading-tight group-hover:text-brand transition-colors duration-300">
                {m.name}
              </h3>
              <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.15em] text-brand">{m.role}</p>
              <p className="mt-5 text-sm text-brand-soft font-light leading-relaxed flex-1">{m.note}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Team;
